import { render, staticRenderFns } from "./ProductReparationDataPage.vue?vue&type=template&id=65281582&"
import script from "./ProductReparationDataPage.vue?vue&type=script&lang=js&"
export * from "./ProductReparationDataPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports